/* HaloHush OS2 components. Purchasing is handled by the theme's native product-form. */
(() => {
  'use strict';
  if (window.HaloHushPDP) { window.HaloHushPDP.init(document); return; }
  const live = new Map();
  const motion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  function initSection(root) {
    if (live.has(root)) return;
    const abort = new AbortController();
    const cleanups = [];
    const on = (target, event, fn, options = {}) => target?.addEventListener(event, fn, { ...options, signal: abort.signal });
    const q = (s) => root.querySelector(s);
    const qa = (s) => [...root.querySelectorAll(s)];
    const scrollToIndex = (track, index) => {
      const child = track?.children[index];
      if (child) track.scrollTo({left: child.offsetLeft - track.children[0].offsetLeft, behavior: motion()});
    };
    on(root,'shopify:block:select',event => {
      const card=event.target.closest('.review-card');
      const track=card?.closest('[data-hhp-track]');
      if(track)scrollToIndex(track,[...track.children].indexOf(card));
    });
    root.querySelectorAll('[data-hhp-carousel]').forEach(carousel => {
      const track = carousel.querySelector('[data-hhp-track]');
      if (!track || !track.children.length) return;
      const count = track.children.length;
      let index = 0;
      const current = carousel.querySelector('[data-hhp-current]');
      const total = carousel.querySelector('[data-hhp-total]');
      if (total) total.textContent = count;
      function update() {
        index = [...track.children].reduce((best, child, i) => Math.abs(child.offsetLeft - track.children[0].offsetLeft - track.scrollLeft) < Math.abs(track.children[best].offsetLeft - track.children[0].offsetLeft - track.scrollLeft) ? i : best, 0);
        if (current) current.textContent = index + 1;
      }
      on(carousel.querySelector('[data-hhp-prev]'), 'click', () => scrollToIndex(track, (index - 1 + count) % count));
      on(carousel.querySelector('[data-hhp-next]'), 'click', () => scrollToIndex(track, (index + 1) % count));
      on(track, 'scroll', update, {passive: true});
      on(track, 'keydown', e => {if (e.target === track && ['ArrowLeft','ArrowRight'].includes(e.key)) {e.preventDefault(); scrollToIndex(track, Math.max(0,Math.min(count-1,index+(e.key==='ArrowRight'?1:-1))));}});
    });
    if (root.hasAttribute('data-hhp-product')) {
      let data;
      try { data = JSON.parse(q('[data-hhp-product-data]')?.textContent || '{}'); } catch { data = {}; }
      const form = q('product-form form');
      const select = q('[data-hhp-variant]');
      const quantity = q('[data-hhp-quantity]');
      const submit = q('[data-hhp-submit]');
      const packs = qa('[data-hhp-pack]');
      const sticky = q('[data-hhp-sticky]');
      const stickyButton = q('[data-hhp-sticky-add]');
      let variant = (data.variants || []).find(v => String(v.id) === String(select?.value || data.selected));
      let canBuy = !!variant?.available;
      let formatter;
      try { formatter = new Intl.NumberFormat(data.locale || 'es-ES',{style:'currency',currency:data.currency || 'EUR'}); } catch { formatter = new Intl.NumberFormat('es-ES',{style:'currency',currency:'EUR'}); }
      const money = cents => formatter.format(Number(cents || 0) / 100);
      // Liquid variant amounts already use the customer's presentment currency.
      // Shopify expresses even zero-decimal currencies in hundredths (JPY 1000 = 100000).
      const precision = formatter.resolvedOptions().maximumFractionDigits;
      const quantum = 100 / Math.pow(10, precision);
      const roundAmount = amount => {
        const scaled = amount / quantum;
        return Math.round(scaled + Number.EPSILON * Math.max(1, Math.abs(scaled)) * 4) * quantum;
      };
      const percentFormat = new Intl.NumberFormat(data.locale || 'es-ES', {maximumFractionDigits: 8});
      function packAmounts(input) {
        const qty = Math.max(1, Number(input?.dataset.quantity) || 1);
        const discountBasis = Math.round(Math.max(0, Math.min(100, Number(input?.dataset.discount) || 0)) * 100);
        const discount = discountBasis / 100;
        const base = Number(variant?.price || 0) * qty;
        const total = roundAmount(base * (10000 - discountBasis) / 10000);
        const compare = Number(variant?.compare || 0) * qty;
        return {qty, discount, base, total, compare, unit: total / qty};
      }
      function packText(text, amounts) {
        const values = {discount: percentFormat.format(amounts.discount) + '%', saving: money(amounts.base - amounts.total), total: money(amounts.total), base_total: money(amounts.base), unit_price: money(amounts.unit), compare_total: amounts.compare > amounts.total ? money(amounts.compare) : ''};
        return String(text || '').replace(/\{(discount|saving|total|base_total|unit_price|compare_total)\}/g, (_, key) => values[key]);
      }
      const setAll = (selector, value) => document.querySelectorAll('.hhp ' + selector).forEach(el => {el.textContent = value || '';});
      const galleryTrack = q('[data-hhp-gallery-track]');
      const slides = galleryTrack ? [...galleryTrack.children] : [];
      let galleryIndex = 0;
      const updateGallery = () => {
        if (!galleryTrack || !slides.length) return;
        galleryIndex = Math.max(0, Math.min(slides.length - 1, Math.round(galleryTrack.scrollLeft / (galleryTrack.clientWidth || 1))));
        qa('[data-hhp-thumb]').forEach((thumb,i) => thumb.setAttribute('aria-current', String(i === galleryIndex)));
        const count = q('[data-hhp-gallery-count]'); if (count) count.textContent = `${galleryIndex + 1} / ${slides.length}`;
        const zoom = q('[data-hhp-zoom]'); if (zoom) zoom.hidden = !slides[galleryIndex].querySelector('img');
      };
      on(galleryTrack,'scroll',updateGallery,{passive:true});
      qa('[data-hhp-thumb]').forEach(button => on(button,'click',() => scrollToIndex(galleryTrack,Number(button.dataset.hhpThumb))));
      on(q('[data-hhp-gallery-prev]'),'click',() => scrollToIndex(galleryTrack,(galleryIndex-1+slides.length)%slides.length));
      on(q('[data-hhp-gallery-next]'),'click',() => scrollToIndex(galleryTrack,(galleryIndex+1)%slides.length));
      on(galleryTrack,'keydown',e => {if(e.target === galleryTrack && ['ArrowRight','ArrowLeft'].includes(e.key)){e.preventDefault();scrollToIndex(galleryTrack,Math.max(0,Math.min(slides.length-1,galleryIndex+(e.key==='ArrowRight'?1:-1))));}});
      function variantMedia() {
        const index = slides.findIndex(slide => String(slide.dataset.mediaId) === String(variant?.media));
        if(index >= 0) scrollToIndex(galleryTrack,index);
      }
      const availability = document.createElement('p');
      availability.className = 'hhp-errors'; availability.hidden = true; availability.setAttribute('role','status');
      submit?.parentElement.appendChild(availability);
      function sync() {
        if (!form || !select || !quantity || !submit) return;
        variant = (data.variants || []).find(v => String(v.id) === String(select.value));
        const pack = packs.find(p => p.checked);
        const selected = packAmounts(pack);
        const qty = selected.qty;
        quantity.value = String(qty);
        const total = money(selected.total);
        setAll('[data-selected-total]', total);
        setAll('[data-selected-units]', pack?.dataset.title || `${qty}`);
        document.querySelectorAll('.hhp [data-selected-unit-price]').forEach(el => {
          const label = el.dataset.hhpUnitLabel ?? pack?.dataset.unitLabel ?? 'por bote';
          el.textContent = `${money(selected.unit)} ${label}`.trim();
        });
        setAll('[data-selected-saving]', packText(pack?.dataset.saving, selected));
        setAll('[data-shipping]', packText(pack?.dataset.shipping, selected));
        qa('[data-hhp-native-price]').forEach(el => {el.textContent = money(variant?.price);});
        qa('[data-hhp-native-compare]').forEach(el => {el.textContent = money(variant?.compare); el.hidden = !(variant?.compare > variant?.price);});
        packs.forEach(input => {
          const card = input.closest('.pack-card');
          const amounts = packAmounts(input);
          card?.classList.toggle('is-selected', input.checked);
          const price = card?.querySelector('[data-hhp-pack-price]');
          const unit = card?.querySelector('[data-hhp-pack-unit]');
          const compare = card?.querySelector('[data-hhp-pack-compare]');
          if (price) price.textContent = money(amounts.total);
          if (unit) unit.textContent = `${money(amounts.unit)} ${input.dataset.unitLabel || ''}`.trim();
          if (compare) {compare.textContent = money(amounts.compare); compare.hidden = !(amounts.compare > amounts.total);}
          card?.querySelectorAll('[data-hhp-text]').forEach(el => {el.textContent = packText(el.dataset.hhpText, amounts);});
        });
        const rulesOK = qty >= (variant?.min || 1) && (!variant?.max || qty <= variant.max) && qty % (variant?.increment || 1) === 0;
        canBuy = !!variant?.available && rulesOK;
        const busy = submit.classList.contains('is-loading') || submit.classList.contains('is-success');
        submit.disabled = !canBuy || busy;
        if(stickyButton) stickyButton.disabled = !canBuy || busy;
        document.querySelectorAll('.hhp [data-hhp-final-add]').forEach(button => {button.disabled = !canBuy || busy;});
        const label = canBuy ? `${submit.dataset.label}${submit.dataset.showTotal === 'true' ? ' · '+total : ''}` : submit.dataset.soldOut;
        const inner = submit.querySelector('[data-add-to-cart-text]'); if(inner) inner.textContent = label;
        if(stickyButton) stickyButton.firstChild.textContent = canBuy ? stickyButton.dataset.label : submit.dataset.soldOut;
        availability.hidden = rulesOK || !variant?.available;
        availability.textContent = availability.hidden ? '' : 'Esta cantidad no está disponible para la variante elegida. Selecciona otro pack.';
      }
      packs.forEach(pack => on(pack,'change',sync));
      on(document,'halohush:refresh',sync);
      on(select,'change',() => {
        sync(); variantMedia();
        if (!window.Shopify?.designMode && variant) {
          const url = new URL(window.location.href);url.searchParams.set('variant',variant.id);window.history.replaceState({},'',url);
        }
        root.dispatchEvent(new CustomEvent('halohush:variant-change',{bubbles:true,detail:{variant}}));
      });
      // Capture validation happens before the theme's existing submit handler.
      on(form,'submit',event => {if(!canBuy){event.preventDefault();event.stopImmediatePropagation();}}, {capture:true});
      on(stickyButton,'click',() => { if(submit && !submit.disabled) form.requestSubmit(submit); });
      const observeBusy = new MutationObserver(() => {
        if (!canBuy && submit && !submit.disabled) submit.disabled = true;
        if(stickyButton) stickyButton.disabled = !canBuy || !!submit?.disabled;
        document.querySelectorAll('.hhp [data-hhp-final-add]').forEach(button => {button.disabled = !canBuy || !!submit?.disabled;});
      });
      if(submit) observeBusy.observe(submit,{attributes:true,attributeFilter:['disabled','class']});
      cleanups.push(() => observeBusy.disconnect());
      const stickyUpdate = () => {
        if(!sticky || !submit) return;
        const closing = document.querySelector('.hhp .closing');
        const closingRect = closing?.getBoundingClientRect();
        const closingVisible = closingRect && closingRect.top < window.innerHeight && closingRect.bottom > 0;
        sticky.hidden = submit.getBoundingClientRect().bottom > 0 || !!closingVisible;
      };
      on(window,'scroll',stickyUpdate,{passive:true});on(window,'resize',stickyUpdate,{passive:true});
      on(document,'halohush:select-pack',event => {
        const chosen = packs.find(p => Number(p.dataset.quantity) === Number(event.detail.quantity));
        if(chosen){chosen.checked=true;sync();chosen.closest('.pack-card')?.scrollIntoView({behavior:motion(),block:'center'});chosen.focus({preventScroll:true});}
      });
      const zoomDialog = q('[data-hhp-zoom-dialog]');
      on(q('[data-hhp-zoom]'),'click',() => {
        const img = slides[galleryIndex]?.querySelector('img');if(!img || !zoomDialog)return;
        const target = zoomDialog.querySelector('img'); target.src = img.currentSrc || img.src; target.alt = img.alt; zoomDialog.showModal();
      });
      on(q('[data-hhp-zoom-close]'),'click',() => zoomDialog?.close());
      on(zoomDialog,'click',e => {if(e.target===zoomDialog){const rect=zoomDialog.getBoundingClientRect();if(e.clientX<rect.left || e.clientX>rect.right || e.clientY<rect.top || e.clientY>rect.bottom)zoomDialog.close();}});
      on(root,'shopify:block:select',event => {
        const block = event.target.closest('[data-gallery-block]');
        if(block) scrollToIndex(galleryTrack,slides.indexOf(block));
        const pack = event.target.querySelector('[data-hhp-pack]');if(pack){pack.checked=true;sync();}
      });
      // Home pack links carry only the requested quantity; Shopify owns prices and checkout.
      if (!window.Shopify?.designMode) {
        const requestedPack = new URLSearchParams(window.location.search).get('hhp_pack');
        const requestedInput = packs.find(p => p.dataset.quantity === requestedPack);
        if (requestedInput) requestedInput.checked = true;
      }
      sync();updateGallery();stickyUpdate();
      if (data.selected) requestAnimationFrame(variantMedia);
      cleanups.push(()=>availability.remove());
    }
    live.set(root,()=>{abort.abort();cleanups.forEach(fn=>fn());});
  }
  function init(scope) {if(scope.matches?.('[data-hhp-section]'))initSection(scope);scope.querySelectorAll?.('[data-hhp-section]').forEach(initSection);}
  window.HaloHushPDP = {init};
  document.addEventListener('shopify:section:load',event => {init(event.target);document.dispatchEvent(new Event('halohush:refresh'));});
  document.addEventListener('shopify:section:unload',event => {for(const [root,cleanup] of live){if(root===event.target||event.target.contains(root)){cleanup();live.delete(root);}}});
  document.addEventListener('click',event => {const final=event.target.closest('[data-hhp-final-add]');if(final){const main=document.querySelector('[data-hhp-product] [data-hhp-submit]');const form=main?.closest('form');if(main && form && !main.disabled){form.requestSubmit(main);}else{document.getElementById('HHProduct')?.scrollIntoView({behavior:motion()});}return;}const link=event.target.closest('[data-hhp-select-pack]');if(link){event.preventDefault();document.dispatchEvent(new CustomEvent('halohush:select-pack',{detail:{quantity:link.dataset.hhpSelectPack}}));}});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document),{once:true});else init(document);
})();
